module.exports = __webpack_public_path__ + "img/SnowDay_EGM.584853a8.png";